module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-513.7ae8196.woff2";